import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import register from 'preact-custom-element';
export default function Layout({ 'layout-header': header, 'layout-main': main, 'layout-aside': aside, }) {
    return (_jsxs(_Fragment, { children: [_jsx("header", { part: "header", children: header }), _jsx("div", { part: "main", children: main }), aside && _jsx("aside", { part: "aside", children: aside })] }));
}
register(Layout, 'locator-layout', [], { shadow: true });
